import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { PersistenceModule } from 'angular-persistence';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BackendService } from './services/backend.service';
import { WhereToBuyComponent } from './where-to-buy/where-to-buy.component';
import { SendWishListToDealerComponent } from './send-wish-list-to-dealer/send-wish-list-to-dealer.component';
import { MatTooltipModule } from '@angular/material/tooltip';


import {
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCardModule,
    MatTooltip
} from '@angular/material';

import { BusySpinnerComponent } from './busy-spinner/busy-spinner.component';
import { CdkTableModule } from '@angular/cdk/table';
import { DataStorageService } from './services/data-storage.service';
import { SentWishlistDialogComponent } from './dialogs/sent-wishlist-dialog/sent-wishlist-dialog';
import { RecaptchaTokenService } from './services/recaptcha-token.service';
import { InsertCaptchaDialogComponent } from './dialogs/insert-captcha-dialog/insert-captcha-dialog';
import { GenericErrorDialogComponent } from './dialogs/generic-error-dialog/generic-error-dialog';
import { IncorrectCaptchaDialogComponent } from './dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog';
import { IncorrectCountryDialogComponent } from './dialogs/incorrect-country-dialog/incorrect-country-dialog';
import { LimitErrorDialogComponent } from './dialogs/limit-error-dialog/limit-error-dialog';
import { OverQueryLimitDialogComponent } from './dialogs/over-query-limit-dialog/over-query-limit-dialog';
import { NotFoundDialogComponent } from './dialogs/not-found-dialog/not-found-dialog';
import { NoResellersFoundDialogComponent } from './dialogs/no-resellers-found-dialog/no-resellers-found-dialog';
import { CleanProductCodePipe } from './pipes/clean-product-code.pipe';
import { GoogleMapsService } from './services/google-maps.service';
import { MapsContentComponent } from './maps-content/maps-content.component';
import { ConfigurationService } from './services/configuration.service';
import { LocalizationService } from './services/localization.service';
import { RedirectLocaleComponent } from './redirect-locale/redirect-locale.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

@NgModule({
    declarations: [
        AppComponent,
        RedirectLocaleComponent,
        WhereToBuyComponent,
        SendWishListToDealerComponent,
        BusySpinnerComponent,
        LimitErrorDialogComponent,
        SentWishlistDialogComponent,
        InsertCaptchaDialogComponent,
        GenericErrorDialogComponent,
        IncorrectCaptchaDialogComponent,
        IncorrectCountryDialogComponent,
        OverQueryLimitDialogComponent,
        NotFoundDialogComponent,
        NoResellersFoundDialogComponent,
        CleanProductCodePipe,
        CleanProductCodePipe,
        MapsContentComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpModule,
        ReactiveFormsModule,
        // AngularGooglePlaceModule,
        CdkTableModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatNativeDateModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        AppRoutingModule,
        MatTooltipModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyA-1A1UDEvSew-d5Pd1RIZzDFQpAANa0eU',
            libraries: ['places']
        }),
        RecaptchaModule.forRoot({
            siteKey: '6LcDmkQUAAAAAC6gln7-oYrabL6t6Qm4biYTQq82',
        }),
        PersistenceModule,
        GooglePlaceModule
    ],
    entryComponents: [
        LimitErrorDialogComponent,
        SentWishlistDialogComponent,
        InsertCaptchaDialogComponent,
        GenericErrorDialogComponent,
        IncorrectCaptchaDialogComponent,
        IncorrectCountryDialogComponent,
        NotFoundDialogComponent,
        NoResellersFoundDialogComponent,
        OverQueryLimitDialogComponent,
        RedirectLocaleComponent
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'it' },
        BackendService,
        DataStorageService,
        RecaptchaTokenService,
        GoogleMapsService,
        GoogleMapsAPIWrapper,
        ConfigurationService,
        LocalizationService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts